import { BatchPreviewTable } from "../batch-preview-table";
import { BatchPreviewTransitionPage } from "../batch-preview-transition-page";

import { useBatchPreviewInterventionTransitionPage } from "./batch-preview-intervention-transition-page.hook";

export const BatchPreviewInterventionTransitionPage = () => {
  const { interventions, loading, columns } =
    useBatchPreviewInterventionTransitionPage();

  return (
    <BatchPreviewTransitionPage model="intervention">
      <BatchPreviewTable
        model="intervention"
        items={interventions}
        loading={loading}
        columns={columns}
      />
    </BatchPreviewTransitionPage>
  );
};
